<!-- ======= Header ======= -->
<header id="header" class="fixed-top header-transparent">
  <div class="container d-flex align-items-center justify-content-between">
    <div class="logo">
      <a
        ><img
          src="../../../assets/images/TalH Logo 01 - Positive-01.png"
          alt=""
          class="img-fluid"
      /></a>
    </div>

    <nav id="navbar" class="navbar">
      <ul>
        <li>
          <a class="nav-link" [routerLink]="['/faq/AboutValueCapital']">{{
            "General.ABOUT_VCapital" | translate
          }}</a>
        </li>
        <!-- <li><a class="nav-link" [routerLink]="['/opportunities/opportunity-list']">{{ 'OPPORTUNITIES' | translate }}</a></li> -->
        <li>
          <a class="nav-link" [routerLink]="['/faq/FAQ']">{{
            "General.FAQ" | translate
          }}</a>
        </li>
        <li>
          <a class="nav-link" [routerLink]="['/faq/SupportAndHelp']">{{
            "General.CONTACT_US" | translate
          }}</a>
        </li>
      </ul>
      <ul>
        <li class="lang-toggle-item">
          <app-language-toggle></app-language-toggle>
        </li>
        <li>
          <a class="getstarted" [routerLink]="['/authentication/login']">{{
            "General.GET_STARTED" | translate
          }}</a>
        </li>
      </ul>
      <i class="bi bi-list mobile-nav-toggle"></i>
    </nav>
    <!-- .navbar -->
  </div>
</header>
<!-- End Header -->

<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex align-items-center">
  <div class="container">
    <div class="row">
      <div
        class="col-lg-6 d-lg-flex flex-lg-column align-items-stretch order-2 order-lg-1 hero-img"
      >
        <img
          src="../../../assets/images/Mobile-img.png"
          class="img-fluid"
          alt=""
        />
      </div>
      <div
        class="col-lg-6 d-lg-flex flex-lg-column justify-content-center align-items-stretch pt-5 pt-lg-0 order-1 order-lg-2"
      >
        <div>
          <h1>
            <span class="secondary_color hero_sec_title">Tal</span
            ><br />
            {{ "Home.FINANCIAL_FUTURE_EASILY" | translate }}
          </h1>
          <h2>{{ "Home.LOREM_IPSUM_DESCRIPTION" | translate }}</h2>
          <h4>{{ "Home.DOWNLOAD_APP_NOW" | translate }}</h4>

          <div class="row">
            <div class="col-6 col-lg-4">
              <a href="">
                <img
                  src="../../../assets/images/google-play-black.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </div>
            <div class="col-6 col-lg-4">
              <a href="">
                <img
                  src="../../../assets/images/store-apple-app-black.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Hero -->

<main id="main">
  <!-- ======= App Features Section ======= -->
  <section id="features" class="features">
    <div class="container">
      <div class="section-title">
        <h2>{{ "Home.OUR_FEATURES" | translate }}</h2>
      </div>

      <div class="row">
        <div class="col-lg-12 align-items-center">
          <div class="content justify-content-center">
            <div class="row">
              <div class="col-md-6 mb-1">
                <div class="icon-box align-items-center d-flex">
                  <i class="ri-money-dollar-circle-line"></i>
                  <h4>
                    {{ "Home.MULTIPLE_INVESTMENT_OPPORTUNITIES" | translate }}
                  </h4>
                </div>
              </div>

              <div class="col-md-6 mb-1">
                <div class="icon-box align-items-center d-flex">
                  <i class="ri-magic-line"></i>
                  <h4>{{ "Home.SIMPLE_EASY_REGISTRATION" | translate }}</h4>
                </div>
              </div>

              <div class="col-md-6 mb-1">
                <div class="icon-box align-items-center d-flex">
                  <i class="ri-command-fill"></i>
                  <h4>{{ "Home.FOR_ALL" | translate }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- End App Features Section -->

  <!-- ======= Opportunities Section ======= -->

  <section id="Opportunities" class="Opportunities">
    <div class="container">
      <div class="section-title">
        <h2>{{ "Home.OPPORTUNITIES" | translate }}</h2>
        <p>{{ "Home.CHECK_LATEST_OPPORTUNITIES" | translate }}</p>
      </div>
      <nav id="navbar" class="navbar">
        <div class="navbar_items">
          <ul>
            <li>
              <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Current }"
                (click)="filter(fundStatus.Current)">{{ "Opportunities.Current Funds" | translate }}</a>
            </li>
            <li>
              <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Upcoming }"
                (click)="filter(fundStatus.Upcoming)">{{ "Opportunities.Upcoming Funds" | translate }}</a>
            </li>
            <li>
              <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Ended }"
                (click)="filter(fundStatus.Ended)">{{ "Opportunities.Ended Funds" | translate }}</a>
            </li>
          </ul>
        </div>
      </nav>
      <nav id="navbar" class="navbar mt-4">
      
        <div class="navbar_items">
          <ul>
            <li>
              <a
              class="nav-link menu_links cursor-pointer"
              [ngClass]="{ active: !filterFundType }"
              (click)="filter(filterFundStatus)"
              >{{ "Shared.ALL" | translate }}</a>
            </li>
            <li>
              <a
              class="nav-link menu_links cursor-pointer"
              [ngClass]="{ active: filterFundType == fundTypes.OpenFund }"
              (click)="filter(filterFundStatus,fundTypes.OpenFund)"
              >{{ "Home.Open Fund" | translate }}</a
            >
  
            </li>
            <li>
              <a
              class="nav-link menu_links cursor-pointer"
              [ngClass]="{ active: filterFundType == fundTypes.CloseFund }"
              (click)="filter(filterFundStatus,fundTypes.CloseFund)"
              >{{ "Home.Closed Fund" | translate }}</a
            >
            </li>
          </ul>
        </div>
      </nav>
      <div class="row gy-4 mt-1 mt-sm-2 mt-md-3 mt-lg-4" *ngIf="opportunities.length">
        <div class="col-xl-4 col-md-6 mb-2" *ngFor="let item of opportunities">
          <div [ngClass]="{ 'opportunity-container': item.isCompleted }">
            <div class="Opportunity">
              <div class="Opportunity-img">
               
                <span class="unit_price">{{ "Opportunities.UNIT_PRICE" | translate }}
                  {{ item.unitPrice | number }} {{'Shared.SAR'|translate}}</span>
                  <img [src]="item.coverPhotoURL ||item.companylogoUrl||'../../../assets/images/opportunity-img.png' " alt="" class="w-100" />

              </div>
  
              <div class="d-flex align-items-center">
                <img [src]="item.companylogoUrl" alt="" class="img-fluid Opportunity-comp-img flex-shrink-0" />
                <div class="comp-data">
                  <p class="opportunity-comp">
                    {{ "Opportunities.BY_COMPANY" | translate }}
                    {{ item.companyName }}.
                  </p>
                  <h5>{{ item.fundName }}</h5>
                </div>
              </div>
              <p class=" mt-4 lite-color font-weight-500 font-size-3">{{ "Opportunities.Fund Type" | translate }} <span class="font-weight-700 font-size-3 dark-color">{{"Opportunities."+item.fundType|translate}}</span></p>
              <div class="row d-flex align-items-center py-3" *ngIf="item.fundType==fundTypes.CloseFund">
                <div class="col-4 px-1">
                  <div class="info_section">
                    <p>{{ "Opportunities.CITY" | translate }}</p>
                    <h6>{{ item.fundLocation }}</h6>
                  </div>
                </div>
  
                <div class="col-4 px-1">
                  <div class="info_section">
                    <p>{{ "common.financing_period" | translate }}</p>
                    <h6>{{ item.durationPerMonth }}</h6>
                  </div>
                </div>
  
                <div class="col-4 px-1">
                  <div class="info_section">
                    <p>{{ "common.roi" | translate }}</p>
                    <h6>{{ item.expectedTotalProfit }}</h6>
                  </div>
                </div>
              </div>
              <div class="row d-flex align-items-center py-3" *ngIf="item.fundType==fundTypes.OpenFund" >
                <div class="col-4 px-1">
                  <div class="info_section">
                    <p>{{ "Opportunities.PRICE_SINCE_ESTABLISHMENT" | translate }}</p>
                    <h6>{{ item.establishmentPrice | number }} {{'Shared.SAR'|translate}}</h6>
                  </div>
                </div>
  
                <div class="col-4 px-1">
                  <div class="info_section">
                    <p>{{ "Opportunities.YEAR_TO_DATE" | translate }}</p>
                    <h6>{{ item.ytdPrice | number }} {{'Shared.SAR'|translate}}</h6>
                  </div>
                </div>
  
                <div class="col-4 px-1">
                  <div class="info_section">
                    <p>{{ "Opportunities.PERCENTAGE_CHANGE" | translate }}</p>
                    <h6>{{ item.percentageOfChange }}%</h6>
                  </div>
                </div>
              </div>
  
              <div class="row progress_section" *ngIf="item.totalUnits>0">
                <div class="col-6 text-start">
                  <p>{{ "Opportunities.FUND_TARGET" | translate }}</p>
                  <h6>{{ item.projectTotalValue | number }} {{'Shared.SAR'|translate}}</h6>
                </div>
                <div class="col-6 text-end">
                  <p>{{ "Opportunities.COMPLETED" | translate }}</p>
                  <h6>{{ item.soldPercentage }}%</h6>
                </div>
                <div class="col-12">
                  <mat-progress-bar class="example-margin" [color]="color" [mode]="mode" [value]="item.soldPercentage">
                  </mat-progress-bar>
                </div>
              </div>
  
              <div class="row d-flex align-items-center justify-content-center pt-4 pm-2" *ngIf="!item.isCompleted &&(filterFundStatus==fundStatus.Current || filterFundStatus==fundStatus.Upcoming)">
                <a class="opportunity_details" [routerLink]="[
                    '/opportunities/opportunity-details/' + item.opportunityid
                  ]">{{ "Opportunities.VIEW_DETAILS" | translate }} <i [ngClass]="{'ri-arrow-right-line':languageService.currentLanguage=='en','ri-arrow-left-line':languageService.currentLanguage=='ar'}"></i></a>
              </div>
            </div>
            <img src="../../../../assets/images/Stamp.svg" class="stamp" alt="Stamp" *ngIf="item.isCompleted" />
          </div>
        </div>
       
      </div>
    </div>
  </section>

  <!-- End Opportunities Section -->
</main>
<!-- End #main -->
